export const APPLICANT_COMPARISON_MIN_CANDIDATES = 2

export const QA_NAME_APPLICANT_COMPARISON_TABLE = 'applicantComparison'

export const QA_NAME_APPLICANT_COMPARISON_RETRY = 'applicantComparisonRetry'

export const QA_NAME_APPLICANT_COMPARISON_PROFILE = 'applicantComparisonProfile'

export const QA_NAME_APPLICANT_COMPARISON_SELECT = 'applicantComparisonSelect'

export const QA_NAME_APPLICANT_COMPARISON_APPROVE = 'applicantComparisonApprove'

export const QA_NAME_APPLICANT_COMPARISON_SELECTED =
  'applicantComparisonSelected'

export const QA_NAME_APPLICANT_COMPARISON_DOCUMENTS =
  'applicantComparisonDocuments'

export const QA_NAME_APPLICANT_COMPARISON_BAND = 'applicantComparisonBand'

export const QA_NAME_APPLICANT_COMPARISON_PROVIDER =
  'applicantComparisonProvider'

export const QA_NAME_APPLICANT_COMPARISON_EXPIRED = 'applicantComparisonExpired'

export const QA_NAME_APPLICANT_COMPARISON_PROTECTED =
  'applicantComparisonProtected'

export const QA_NAME_APPLICANT_COMPARISON_CONFLICT =
  'applicantComparisonConflict'

export const APPLICANT_COMPARISON_STATE = {
  empty: 'empty',
  error: 'error',
  grid: 'grid',
  loading: 'loading',
}

export const APPLICANT_COMPARISON_LABEL_COLUMN = 'label'

export const APPLICANT_COMPARISON_COLUMN_PREFIX = 'applicant_'

export const APPLICANT_COMPARISON_LABEL_COLUMN_WIDTH = 200

export const APPLICANT_COMPARISON_COLUMN_WIDTH = 240

export const APPLICANT_COMPARISON_ROW = {
  actions: 'actions',
  applicant: 'applicant',
  creditCheck: 'credit_check',
  documents: 'documents',
  fourEyes: 'four_eyes',
  income: 'income_proof_status',
  protected: 'protected_characteristics',
  received: 'received',
}

export const APPLICANT_COMPARISON_ROWS = [
  APPLICANT_COMPARISON_ROW.applicant,
  APPLICANT_COMPARISON_ROW.documents,
  APPLICANT_COMPARISON_ROW.income,
  APPLICANT_COMPARISON_ROW.creditCheck,
  APPLICANT_COMPARISON_ROW.protected,
  APPLICANT_COMPARISON_ROW.received,
  APPLICANT_COMPARISON_ROW.actions,
  APPLICANT_COMPARISON_ROW.fourEyes,
]

export const APPLICANT_COMPARISON_ROW_LABEL_KEY = {
  [APPLICANT_COMPARISON_ROW.applicant]:
    'RentalPortal.ApplicantComparisonApplicantRowKey',
  [APPLICANT_COMPARISON_ROW.creditCheck]:
    'RentalPortal.ApplicantCreditCheckTitleKey',
  [APPLICANT_COMPARISON_ROW.documents]:
    'RentalPortal.ApplicantComparisonDocumentsRowKey',
  [APPLICANT_COMPARISON_ROW.income]:
    'RentalPortal.ApplicantComparisonIncomeRowKey',
  [APPLICANT_COMPARISON_ROW.protected]:
    'RentalPortal.ApplicantComparisonProtectedRowKey',
  [APPLICANT_COMPARISON_ROW.received]:
    'RentalPortal.ListingProfileApplicantsReceivedColumnKey',
}

export const APPLICANT_COMPARISON_INCOME_STATUS = {
  none: 'none',
  uploaded: 'uploaded',
  verified: 'verified',
}

export const APPLICANT_COMPARISON_INCOME_STATUS_LABEL_KEY = {
  [APPLICANT_COMPARISON_INCOME_STATUS.none]:
    'RentalPortal.ApplicantComparisonIncomeNoneKey',
  [APPLICANT_COMPARISON_INCOME_STATUS.uploaded]:
    'RentalPortal.ApplicantDocumentStatusUploadedKey',
  [APPLICANT_COMPARISON_INCOME_STATUS.verified]:
    'RentalPortal.ApplicantDocumentStatusVerifiedKey',
}

export const APPLICANT_COMPARISON_INCOME_STATUS_TEXT_COLOR = {
  [APPLICANT_COMPARISON_INCOME_STATUS.none]: 'var(--secondary-text-color)',
  [APPLICANT_COMPARISON_INCOME_STATUS.uploaded]: 'var(--color-info)',
  [APPLICANT_COMPARISON_INCOME_STATUS.verified]: 'var(--color-success)',
}

export const APPLICANT_COMPARISON_SKELETON_ROWS =
  APPLICANT_COMPARISON_ROWS.length

export const APPLICANT_COMPARISON_POSITION_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
